import React from 'react';
import { Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * The breadcrumb trail every generated-resource page starts with: a link
 * back to myStudySidekick(Dashboard), followed by whatever crumbs the page adds after
 * it.
 *
 * Props:
 *   id          (string)   - Optional ID for the Breadcrumbs element.
 *   rootTo      (string)   - Relative path from this page back to the dashboard.
 *   onRootClick (function) - Optional click handler for the root crumb (e.g. to guard unsaved changes on edit page).
 *   isVisible   (bool)     - Whether to render the trail at all. Defaults to true.
 *   children    (node)     - The page's own crumbs, rendered after the root.
 */
function PageBreadcrumbs({ id, rootTo, onRootClick, isVisible = true, children }) {
  if (!isVisible) return null;
  return (
    <Breadcrumbs className="mss__breadcrumbs" id={id} aria-label="breadcrumb">
      <Link component={RouterLink} to={rootTo} relative="path" onClick={onRootClick}>
        myStudySidekick
      </Link>
      {children}
    </Breadcrumbs>
  );
}

export default PageBreadcrumbs;
